// ============================================================================
// CORE EXPORTS
// ============================================================================

export { default as Commander, type CommandHandler } from "./commander"
export {
  CommandBuilder,
  CommandTemplate,
  command,
  simpleCommand,
} from "./builder"

// ============================================================================
// HOOKS EXPORTS
// ============================================================================

export * from "./hooks"

// ============================================================================
// TYPE EXPORTS
// ============================================================================

export type {
  CommandKey,
  CommandCategory,
  Command,
  EventListener,
  CommandExecutionContext,
  SearchResult,
  SearchOptions,
  ExecutionResult,
  CommanderStats,
} from "./types"

// ============================================================================
// ERROR EXPORTS
// ============================================================================

export {
  CommandError,
  CommandNotFoundError,
  CommandUnavailableError,
  CommandTimeoutError,
  CommandExecutionError,
  createCommandError,
} from "./errors"

// ============================================================================
// UTILITY EXPORTS
// ============================================================================

export {
  generateId,
  normalizeSearchTerm,
  calculateSearchScore,
  getMatchedTerms,
  isValidCommandKey,
  isValidCommand,
  withTimeout,
  delay,
  debounce,
  unique,
  removeItem,
  deepClone,
  PriorityQueue,
} from "./utils"

// ============================================================================
// VERSION
// ============================================================================

export const VERSION = "1.0.0"
